import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { ColorFamilyList } from '@/models/tag/color-family'

export function getEnabledColorFamilyList(
  list: ColorFamilyList,
  behavior: Pick<BehaviorConfig, 'colorFamily'>
): ColorFamilyList {
  const enabledColorFamilies = behavior.colorFamily.enabledNames

  return list.filter(c => enabledColorFamilies.includes(c.name))
}
